/* Copyright (c) 2025 Xperi. All Rights Reserved. */

export const TInfoCardKernelType = {
    TPersonInfoCardKernel: 'tPersonInfoCardKernel' as const,
};

export type TInfoCardKernelType = (typeof TInfoCardKernelType)[keyof typeof TInfoCardKernelType];
